import React, { Component } from 'react'
import { Form, Field } from 'react-final-form'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Button } from '@material-ui/core'
import Paper from '@material-ui/core/Paper'
import Tooltip from '@material-ui/core/Tooltip'
import Grid from '@material-ui/core/Grid'
import Icon from '@material-ui/core/Icon'
import Fab from '@material-ui/core/Fab'
import { connect } from 'react-redux'
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import MenuItem from '@material-ui/core/MenuItem'
import RoleHelper from 'helpers/role'
import TimeZone from 'components/common/Form/TimeZone'
import {
  licenseeFetchList,
  licenseeUpdateLogo,
} from 'reducers/licensee/reducer'
import { Checkbox, Select } from 'components/common/FormInputs'
import CircleLoader from 'components/Loading/CircleLoader'
import Input from 'components/common/Form/Input'
import getValidator, {
  VALIDATOR_IS_EMPTY,
  VALIDATOR_IS_LESS_THEN_255_SYMBOLS,
  VALIDATOR_IS_POSITIVE_INTEGER,
} from 'validation'
import withPromise from 'helpers/withPromise'
import Psfs from 'lib/psfs/Psfs'
import { API_URL_LICENSEE_LIST } from 'constants/index'
import ChangeFileDialog from './ChangeFileDialog'
import messages from './translate'
import './styles.scss'

class LicenseeForm extends Component {
  state = {
    isOpenChangeLogo: false,
    isOpenDataCopy: false,
    licensees: [],
  }

  componentDidMount() {
    const { licenseeFetchList } = this.props

    withPromise(licenseeFetchList, {
      psfs: Psfs.create(API_URL_LICENSEE_LIST)
        .createPagination(1, 'all')
        .addFields(['id', 'name']),
    }).then(data => {
      this.setState({
        licensees: data,
      })
    })
  }

  handleLogoChange = () => {
    this.setState(prevState => ({
      isOpenChangeLogo: !prevState.isOpenChangeLogo,
    }))
  }

  onDataCopyChange = ({ target }) => {
    this.setState({
      isOpenDataCopy: target.checked,
    })
  }

  renderLogoBlock() {
    const {
      currentLicensee,
      intl: { formatMessage },
      formData: {
        licensee: { logoUrl },
      },
    } = this.props
    const currLicensee = currentLicensee.toJS()
    const licenseeLogo = currLicensee.logoUrl || logoUrl

    return (
      <div className="logo">
        {licenseeLogo ? (
          <img src={licenseeLogo} alt={formatMessage(messages.licenseeLogo)} />
        ) : (
          <AddAPhotoIcon fontSize="large" />
        )}
        <div className="overlay">
          <Tooltip title={formatMessage(messages.changeLogo)}>
            <Fab
              variant="round"
              color="primary"
              aria-label="Add"
              className="control-button edit-logo"
              onClick={this.handleLogoChange}>
              <Icon>edit</Icon>
            </Fab>
          </Tooltip>
        </div>
      </div>
    )
  }

  getLicenseeList = () => {
    const { licensees } = this.state

    return licensees.map(({ id, name }) => (
      <MenuItem button component="li" key={`dataType_key_${name}`} value={id}>
        {name}
      </MenuItem>
    ))
  }

  render() {
    const {
      onSubmit,
      roleLevel,
      formData,
      licenseeLoader,
      licenseeUpdateLogo,
      licenseeError,
      intl: { formatMessage },
    } = this.props
    const { isOpenDataCopy, isOpenChangeLogo } = this.state
    const isCreateLicensee = window.location.href.includes('licensees/create')
    const smSize = isCreateLicensee ? 12 : 6
    const isSuperAdmin = roleLevel >= RoleHelper.ROLE_SUPERADMIN_LEVEL
    let licensee = {
      latinAmericanNumberFormat: false,
      visibleInUi: false,
      usaDateFormat: false,
      usaTimeFormat: false,
      mobileJobSyncDaysPast: 3,
      mobileJobSyncDaysAhead: 7,
    }

    if (formData.hasOwnProperty('licensee')) {
      const {
        name,
        timezone,
        visibleInUi,
        latinAmericanNumberFormat,
        usaDateFormat,
        usaTimeFormat,
        mobileJobSyncDaysPast,
        mobileJobSyncDaysAhead,
        duplicateWorkflowsFromLicensee,
        duplicatePoliciesFromLicensee,
      } = formData.licensee

      licensee = {
        name,
        timezone,
        visibleInUi: visibleInUi === undefined ? false : visibleInUi,
        latinAmericanNumberFormat:
          latinAmericanNumberFormat === undefined
            ? false
            : latinAmericanNumberFormat,
        usaDateFormat: usaDateFormat === undefined ? false : usaDateFormat,
        usaTimeFormat: usaTimeFormat === undefined ? false : usaTimeFormat,
        mobileJobSyncDaysPast:
          mobileJobSyncDaysPast === undefined ? 3 : mobileJobSyncDaysPast,
        mobileJobSyncDaysAhead:
          mobileJobSyncDaysAhead === undefined ? 7 : mobileJobSyncDaysAhead,
        duplicateWorkflowsFromLicensee,
        duplicatePoliciesFromLicensee,
      }
    }

    return (
      <Paper className="licensee-paper">
        <Grid container spacing={1}>
          {!isCreateLicensee && (
            <Grid
              item
              container
              alignItems="center"
              justify="center"
              xs={12}
              sm={6}
              className="logo-block">
              {licenseeLoader ? (
                <CircleLoader loading={licenseeLoader} />
              ) : (
                this.renderLogoBlock()
              )}
            </Grid>
          )}
          <Grid item container xs={12} sm={smSize}>
            <Form
              onSubmit={onSubmit}
              initialValues={licensee}
              render={({ handleSubmit, submitting, pristine }) => (
                <form
                  onSubmit={handleSubmit}
                  className="form-basic licensee-form">
                  <Field
                    name="name"
                    type="text"
                    label={formatMessage(messages.name)}
                    component={Input}
                    className="form-control"
                    disabled={submitting}
                    validate={getValidator([
                      VALIDATOR_IS_EMPTY,
                      VALIDATOR_IS_LESS_THEN_255_SYMBOLS,
                    ])}
                    customError={licenseeError}
                  />
                  {isSuperAdmin && <TimeZone submitting={submitting} />}
                  <div className="form-group parameters">
                    <FormControlLabel
                      label={formatMessage(messages.visible)}
                      disabled={submitting}
                      control={
                        <Field
                          name="visibleInUi"
                          component={Checkbox}
                          type="checkbox"
                          color="primary"
                        />
                      }
                    />
                    <FormControlLabel
                      label={formatMessage(messages.latinDigitalFormat)}
                      disabled={submitting}
                      control={
                        <Field
                          name="latinAmericanNumberFormat"
                          component={Checkbox}
                          type="checkbox"
                          color="primary"
                        />
                      }
                    />
                    <FormControlLabel
                      label={formatMessage(messages.usaDateFormat)}
                      disabled={submitting}
                      control={
                        <Field
                          name="usaDateFormat"
                          component={Checkbox}
                          type="checkbox"
                          color="primary"
                        />
                      }
                    />
                    <FormControlLabel
                      label={formatMessage(messages.usaTimeFormat)}
                      disabled={submitting}
                      control={
                        <Field
                          name="usaTimeFormat"
                          component={Checkbox}
                          type="checkbox"
                          color="primary"
                        />
                      }
                    />
                    {isSuperAdmin && (
                      <>
                        <Field
                          name="mobileJobSyncDaysPast"
                          type="number"
                          label={formatMessage(messages.mobileJobSyncDaysPast)}
                          component={Input}
                          className="form-control"
                          disabled={submitting}
                          validate={getValidator([
                            VALIDATOR_IS_EMPTY,
                            VALIDATOR_IS_POSITIVE_INTEGER,
                          ])}
                        />
                        <Field
                          name="mobileJobSyncDaysAhead"
                          type="number"
                          label={formatMessage(messages.mobileJobSyncDaysAhead)}
                          component={Input}
                          className="form-control"
                          disabled={submitting}
                          validate={getValidator([
                            VALIDATOR_IS_EMPTY,
                            VALIDATOR_IS_POSITIVE_INTEGER,
                          ])}
                        />
                      </>
                    )}
                    {isSuperAdmin && isCreateLicensee && (
                      <FormControlLabel
                        label={formatMessage(messages.copyDataFrom)}
                        disabled={submitting}
                        onChange={this.onDataCopyChange}
                        onClick={this.onDataCopyChange}
                        control={
                          <Field
                            name="copyDataFrom"
                            component={Checkbox}
                            type="checkbox"
                            color="primary"
                          />
                        }
                      />
                    )}
                  </div>

                  {isOpenDataCopy && (
                    <div className="form-group duplication">
                      <Field
                        name="duplicateWorkflowsFromLicensee"
                        component={Select}
                        label="Copy workflows"
                        disabled={submitting}
                        formControlProps={{ fullWidth: true }}>
                        {this.getLicenseeList()}
                      </Field>
                      <Field
                        name="duplicatePoliciesFromLicensee"
                        component={Select}
                        label="Copy polices"
                        disabled={submitting}
                        formControlProps={{ fullWidth: true }}>
                        {this.getLicenseeList()}
                      </Field>
                    </div>
                  )}
                  <div className="form-group buttons">
                    <Button
                      href={null}
                      type="submit"
                      color="primary"
                      size="medium"
                      variant="contained"
                      onClick={handleSubmit}
                      disabled={submitting || pristine}>
                      <FormattedMessage {...messages.saveInfo} />
                    </Button>
                  </div>
                </form>
              )}
            />
          </Grid>
          <ChangeFileDialog
            isOpenLogoChange={isOpenChangeLogo}
            onCloseLogoChange={this.handleLogoChange}
            fileUpload={licenseeUpdateLogo}
            entityId={formData.licensee.id}
            title={formatMessage(messages.changeLogo)}
          />
        </Grid>
      </Paper>
    )
  }
}

export default connect(
  state => ({
    roleLevel: state.getIn(['profile', 'roleLevel']),
    licensee: state.getIn(['profile', 'profile', 'licensee']),
    loading: state.getIn(['licensee', 'loading']),
    licenseeLoader: state.getIn(['licensee', 'licenseeLoader']),
    currentLicensee: state.getIn(['licensee', 'currentLicensee']),
  }),
  {
    licenseeUpdateLogo,
    licenseeFetchList,
  },
)(injectIntl(LicenseeForm))
